import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Format date
export function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'Europe/London',
  });
}

// Format date time
export function formatDateTime(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Europe/London',
  });
}

// Format currency (GBP)
export function formatCurrency(amount) {
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
  }).format(amount || 0);
}

// Format system size
export function formatSystemSize(kw) {
  if (!kw) return '0 kW';
  return `${kw.toFixed(1)} kW`;
}

// Status display names
export const STATUS_DISPLAY_NAMES = {
  lead: 'Lead',
  qualified: 'Qualified',
  quote_sent: 'Quote Sent',
  approved: 'Approved',
  deposit_taken: 'Deposit Taken',
  scheduled: 'Scheduled',
  ordered: 'Ordered',
  pre_installation: 'Pre-Installation',
  in_progress_installation: 'In Progress (Installation)',
  in_progress_invoiced: 'In Progress (Invoiced)',
  in_progress_handover: 'In Progress (Handover)',
  completed: 'Completed',
  archived: 'Archive/Lost',
};

// Status colors for badges
export const STATUS_COLORS = {
  lead: 'bg-slate-100 text-slate-700 border-slate-200',
  qualified: 'bg-blue-100 text-blue-700 border-blue-200',
  quote_sent: 'bg-purple-100 text-purple-700 border-purple-200',
  approved: 'bg-amber-100 text-amber-700 border-amber-200',
  deposit_taken: 'bg-indigo-100 text-indigo-700 border-indigo-200',
  scheduled: 'bg-cyan-100 text-cyan-700 border-cyan-200',
  ordered: 'bg-orange-100 text-orange-700 border-orange-200',
  in_progress_installation: 'bg-yellow-100 text-yellow-800 border-yellow-200',
  in_progress_invoiced: 'bg-yellow-100 text-yellow-800 border-yellow-200',
  in_progress_handover: 'bg-yellow-100 text-yellow-800 border-yellow-200',
  completed: 'bg-emerald-100 text-emerald-700 border-emerald-200',
  archived: 'bg-slate-200 text-slate-600 border-slate-300',
};

// Project stages in order (active pipeline - excludes completed/archived)
export const PROJECT_STAGES = [
  'lead',
  'qualified',
  'quote_sent',
  'approved',
  'deposit_taken',
  'scheduled',
  'ordered',
  'in_progress_installation',
  'in_progress_invoiced',
  'in_progress_handover',
  'completed',
  'archived',
];

// Property types
export const PROPERTY_TYPES = [
  { value: 'residential', label: 'Residential' },
  { value: 'commercial', label: 'Commercial' },
  { value: 'industrial', label: 'Industrial' },
  { value: 'rural', label: 'Rural' },
];

// Roof types
export const ROOF_TYPES = [
  { value: 'tile', label: 'Tile' },
  { value: 'metal', label: 'Metal/Colorbond' },
  { value: 'flat', label: 'Flat' },
  { value: 'slate', label: 'Slate' },
  { value: 'shingle', label: 'Shingle' },
  { value: 'concrete', label: 'Concrete' },
];

// Roof orientations
export const ROOF_ORIENTATIONS = [
  { value: 'north', label: 'North' },
  { value: 'south', label: 'South' },
  { value: 'east', label: 'East' },
  { value: 'west', label: 'West' },
  { value: 'north-east', label: 'North-East' },
  { value: 'north-west', label: 'North-West' },
  { value: 'south-east', label: 'South-East' },
  { value: 'south-west', label: 'South-West' },
];

// Installation types
export const INSTALLATION_TYPES = [
  { value: 'solar', label: 'Solar PV' },
  { value: 'electrical', label: 'Electrical' },
  { value: 'both', label: 'Solar + Electrical' },
  { value: 'battery', label: 'Battery Storage' },
  { value: 'battery_only', label: 'Battery Only' },
  { value: 'solar_battery', label: 'Solar + Battery' },
];
